// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2a82c","infoBtn":"quickbooks_infoBtn__2IC30","formBox":"quickbooks_formBox__19Ji1","formFooter":"quickbooks_formFooter__1RusD"};